import { computed } from 'mobx';

/**
 * 지출내역 모델
 * @window w_tb_ca642w_11
 * @category 일일마감
 */
export class ExpenseModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  spjangcd: string;

  /**
   * 거래처코드
   *
   * **data type** varchar(13)
   */
  cltcd: string;

  /**
   * 지급처명
   *
   * **data type** varchar(100)
   */
  cltnm: string;

  /**
   * 발생일자
   *
   * **data type** varchar(8)
   */
  misdate: string;

  /**
   * 번호
   *
   * **data type** varchar(4)
   */
  misnum: string;

  /**
   * 발생일자2
   *
   * **data type** varchar(8)
   */
  misdate2: string;

  /**
   * 전일미수
   *
   * **data type** long
   */
  beamt: string;

  /**
   * 미지급잔액
   *
   * **data type** number
   */
  misamt: string;

  /**
   * 지급액
   *
   * **data type** number
   */
  iamt: string;

  /**
   * 적요
   *
   * **data type** char(255)
   */
  remark: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.cltcd = data.cltcd || '';
    this.cltnm = data.cltnm || '';
    this.misdate = data.misdate || '';
    this.misnum = data.misnum || '';
    this.misdate2 = data.misdate2 || '';
    this.beamt = data.beamt || '';
    this.misamt = data.misamt || '';
    this.iamt = data.iamt || '';
    this.remark = data.remark || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
